import * as React from 'react';
import { BusinessResponse, BusinessState } from '../business/business.types';
import { AuthState } from '../auth/auth.types';
import Calendar from './calendar';
import * as moment_timezone from 'moment-timezone';
import { Event } from '../calendar/calendar.event.types';
import { DashboardState } from './dashboard.types';
import { transformCalendarEvents } from './dashboard.util';
import { isAdminAccount, isImpersonating } from '../admin/Util';
import { AdminState } from '../admin/admin.types';
import { isCalendarDisabled, isMemberDisabled } from '../util/permission.util';
import { IdleState } from '../idle/Types';
import CommonFeatures from '../commons/CommonFeatures';
import { MembersState } from '../members/members.types';

const DEFAULT_YEAR_RANGE = 2;

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly dashboardState: DashboardState
  readonly membersState: MembersState
  readonly businessState: BusinessState
  readonly idleState: IdleState
  readonly getBusiness: () => Promise<BusinessResponse>
  readonly toSignup: () => void
  readonly toAdminDashboard: () => void
  readonly getCalendarEvents: (from: number, to: number) => Promise<Response>
  readonly getMembers: () => Promise<Response>
};

type States = {
  readonly events: Array<Event>
  readonly loadingMembers: boolean
};

class DashboardComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      events: [],
      loadingMembers: false
    };
  }

  componentDidMount() {
    const { authState, getBusiness, getCalendarEvents, toAdminDashboard, adminState } = this.props;
    
    if (isAdminAccount(authState) && !isImpersonating(adminState)) {
      return toAdminDashboard();
    }
    
    getBusiness();

    if (!isMemberDisabled(authState, adminState)) {
      this.setState(
        {loadingMembers: true},
        () => {
          this.props.getMembers()
          .then(res => {
            switch (this.props.membersState.statusCode) {
              case 200:
                this.setState({loadingMembers: false});
                break;
              default:
                this.setState({loadingMembers: false});
                break;
            }
          });
        }
      );
    }

    // TODO : find a better way to load events later.
    if (!isCalendarDisabled(authState, adminState)) {
      getCalendarEvents(
        moment_timezone().subtract(DEFAULT_YEAR_RANGE, 'year').toDate().getTime(),
        moment_timezone().add(DEFAULT_YEAR_RANGE, 'year').toDate().getTime()
      );
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (
      this.props !== nextProps &&
      nextProps.authState.statusCode === 200 &&
      !nextProps.idleState.expired &&
      nextProps.dashboardState
    ) {
      this.setState({
        events: transformCalendarEvents(nextProps.dashboardState)
      });
    }
  }

  componentWillUnmount() {
    this.setState({loadingMembers: false});
  }

  render() {
    return(
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="row mt-4">
          <div className="col-12">
            <Calendar events={this.state.events} loadingMembers={this.state.loadingMembers}/>
          </div>
        </div>
      </CommonFeatures>
    );
  }
}

export default DashboardComponent;



// WEBPACK FOOTER //
// ./src/dashboard/DashboardComponent.tsx